import { useEffect } from 'react'
import { useFieldArray, useForm } from 'react-hook-form'
import type { MatchCoursesFormType } from '@/schemas/education/match-courses-schema'
import type { StudentRequestedCoursesFormMethods } from '@/types/forms/student-requested-courses-form-methods'
import type { Request } from '@/types/requests/request'

export const useReviewExternalTransferForm = (requestData?: Request | null) => {
  const defaultValues = {
    observation: ''
  }

  const { control, getValues, reset } = useForm<MatchCoursesFormType>({
    defaultValues
  })

  const { fields } = useFieldArray({
    control,
    name: 'courseEquivalences'
  })

  useEffect(() => {
    if (requestData?.courseEquivalences) {
      reset({
        courseEquivalences: requestData.courseEquivalences,
        automaticCourseEquivalences: []
      })
    }
  }, [requestData, reset])

  const formMethods: StudentRequestedCoursesFormMethods = {
    control,
    getValues,
    fields
  }

  return {
    states: {
      formMethods
    }
  }
}
